import React, { useState, useEffect } from 'react';
import TrainerSegmentList from '../components/TrainerSegmentList';
import TrainerSegmentEdit from '../components/TrainerSegmentEdit';
import styled from 'styled-components';

type IProps = {
  trainerSegmentId: number;
};

const TrainerSegment: React.FC<IProps> = ({ trainerSegmentId }) => {
  const [editSegment, setEditSegment] = useState(trainerSegmentId);

  // Load segment when navigated from external source
  useEffect(() => {
    setEditSegment(trainerSegmentId);
  }, [trainerSegmentId]);

  const onEditSegment = (exerciseId: number) => {
    setEditSegment(exerciseId);
  };

  return (
    <Container>
      <TrainerSegmentList onEditSegment={onEditSegment} editingSegmentId={editSegment} />
      <TrainerSegmentEdit trainerSegmentId={editSegment} key={editSegment} />
    </Container>
  );
};

export default TrainerSegment;

const Container = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;
